export default "__VITE_ASSET__BetSLIzx__"